// extracted by mini-css-extract-plugin
module.exports = {"resource":"FJResources_resource__3BUVM","expand":"FJResources_expand__1SRp9"};